/**
 * Show specific step and update UI
 * @param {number} stepIndex - Index of step to show
 * @param {NodeList} steps - All form steps
 * @param {NodeList} stepSegments - Progress segments
 * @param {HTMLElement|null} currentStepText - Element showing current step number
 */
export function showStep(stepIndex, steps, stepSegments, currentStepText) {
	// Show/hide steps
	steps.forEach((step, index) => {
		if (index === stepIndex) {
			step.classList.add('active');
			step.style.display = 'block';
		} else {
			step.classList.remove('active');
			step.style.display = 'none';
		}
	});

	// Update step segments
	updateStepSegments(stepIndex, stepSegments);

	// Update current step text
	updateCurrentStepText(stepIndex, currentStepText);
}

/**
 * Update progress step segments
 * @param {number} stepIndex - Current step index
 * @param {NodeList} stepSegments - Progress segments
 */
function updateStepSegments(stepIndex, stepSegments) {
	stepSegments.forEach((segment, index) => {
		if (index <= stepIndex) {
			segment.classList.add('active');
		} else {
			segment.classList.remove('active');
		}
	});
}

/**
 * Update current step text display
 * @param {number} stepIndex - Current step index
 * @param {HTMLElement|null} currentStepText - Element to update
 */
function updateCurrentStepText(stepIndex, currentStepText) {
	if (currentStepText?.textContent) {
		currentStepText.textContent = stepIndex + 1;
	}
}
